import { get, put } from "./apiClient";

export default {
  async get(facilityId) {
    return await get(
      `facility/${encodeURIComponent(facilityId)}/performanceBands`
    );
  },

  async put(facilityId, performanceBands) {
    return await put(
      `facility/${encodeURIComponent(facilityId)}/performanceBands`,
      performanceBands
    );
  }
};
